import React from 'react';
import Layout from '../components/layout';

/* eslint-disable max-len */
const Settings = () => {
  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
          <iframe
            src="https://player.vimeo.com/video/1099456714?h=b6bd62ca08&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '92%',
              height: '100%',
            }}
            title="Elam-Eric-Income-Planning-Training"
          />
        </div>
        <script src="https://player.vimeo.com/api/player.js"/>
      </div>
    </Layout>
  );
};


{/* <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/1099456684?h=be0a3173dc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Elam-Eric-Annuity-Rate-Watch-Training"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script> */}
{/* <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/1099456714?h=b6bd62ca08&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Elam-Eric-Income-Planning-Training"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script> */}
export default Settings;
